import ApiRelation from "../../../gd/api/graphql/relation"
import RelationsCollection from "../collection"

// Confirms, then drops the row optimistically and deletes the link. Used by
// every host except the task view, which routes through its own manager.
//
// Nothing re-renders from here: removing fires the collection's own bus event
// (BUS_RELATIONS_CHANGED), which is what the hosts subscribe to.
export function removeRelatedItem(relations: RelationsCollection, relationId: ID) {
    gd.modals.confirm.deleteTextMessage(
        'Related item',
        'Are you sure that you want to remove this related item?',
        async () => {
            relations.remove(relationId)
            gd.modal.hide()

            try {
                await ApiRelation.delete(relationId).promise()
            } catch (err: any) {
                gd.modals.other.notification(String(err?.message || 'Failed to remove related item'))
            }
        }
    )
}
